import React from 'react';
import Input from '../../../forms/Input';
import AddressFields from '../AddressFields';
import TimezoneSelect from '../TimezoneSelect';

const OrganizationInput = ({ onInput, data, errors }) => (
    <div className="ckp-admin-forms-body">
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Input
                    errorMessage={errors.name}
                    label="Organization Name *"
                    name="name"
                    onChange={onInput}
                    value={data.name}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <TimezoneSelect label="Working Timezone *" value={data.timeZone} onChange={onInput} />
            </div>
        </div>
        <AddressFields errors={errors} data={data} onInput={onInput} />
    </div>
);

export default OrganizationInput;
